import React from 'react';

interface PrecioConFormatoProps {
  precio: number;
  decimales: number;
}

type FormatNumberOptions = {
  decimalPlaces: number;
  thousandSeparator: string;
  decimalSeparator: string;
};

const formatNumberPropio = (num: number, options: FormatNumberOptions): string => {
  const { decimalPlaces, thousandSeparator, decimalSeparator } = options;

  const fixedNumber = num.toFixed(decimalPlaces);

  // Split the number into integer and decimal parts
  const [integerPart, decimalPart] = fixedNumber.split('.');

  // Add thousand separators to the integer part
  const integerWithSeparators = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

  // Combine the integer part and decimal part with the custom decimal separator
  return decimalPart ? `${integerWithSeparators}${decimalSeparator}${decimalPart}` : integerWithSeparators;
};

const PrecioConFormato: React.FC<PrecioConFormatoProps> = ({ precio, decimales }) => {

  const precioFormateado = formatNumberPropio(precio, {
    decimalPlaces: decimales,
    thousandSeparator: '.',
    decimalSeparator: ','
  });
    
  return <span>{precioFormateado}</span>;
};

export default PrecioConFormato;